import React from "react";
const RemainingTGT = () => {
  return <div> RemainingTGT</div>;
};
export default RemainingTGT;
